<template>
  <div class="home">
    <div class="header">
      <div class="header-left">
        <img v-if="equipment == 'PC'" @click="skipGuanWang" src="@/assets/login-top.png" alt="" srcset="" />
        <img v-else @click="skipGuanWang" src="@/assets/gch.png" alt="" srcset="" />
      </div>
      <div class="header-right">
        <div @click="skipGuanWang('http://www.bjgongcuhui.org.cn')">回到首页</div>
        <div @click="skipGuanWang('https://mp.weixin.qq.com/s/OL8OmniCmUriyrVNZUx8sQ')">我要报名</div>
        <div>
          <el-dropdown>
            <span class="el-dropdown-link">
              个人中心
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="quit">{{ loginText }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
    <h1 style="padding: 15px 0;">调解员培训</h1>
    <div class="video">
      <div class="videoPlay">
        <div class="videoPlay-v">
          <div class="videoEl" ref="videoEl"></div>
        </div>
        <div class="tutorInfo">
          <h2>讲师简介</h2>
          <div class="tutorTop">
            <div class="tutorTopImg"><img
                :src="teacherInfo.teacherHeadUrl ? teacherInfo.teacherHeadUrl : teacherHeadUrl" alt="" srcset=""></div>
            <div class="tutorTopText" v-if="teacherInfo.teacherName">{{ teacherInfo.teacherName }}</div>
            <div class="tutorTopText" v-else>暂无</div>
          </div>
          <div class="tutorText" v-if="teacherInfo.teacherIntro">{{ teacherInfo.teacherIntro }}</div>
          <div class="tutorText" v-else>暂无</div>
        </div>

      </div>

      <div class="video-text" v-if="equipment == 'phone'">
        <div class="videoTextB">{{ videoIntroForm.videoName }}</div>
        <div class="videoTextB" style="text-align: right;color: #8a8a8a;" v-if="videoIntroForm.createDate">上架时间：{{
          videoIntroForm.createDate.split(" ")[0] }}</div>
        <div class="videoTextT">{{ videoIntroForm.videoIntro }}</div>
      </div>

      <div class="videoBody">
        <div class="videoList">
          <h2>课程列表</h2>
          <div class="videoTitleList">
            <!-- <div v-for="(item, index) in videoList" :key="index">
              <div :class="videoIndex == index ? 'listTitle on' : 'listTitle'" @click="chooseVideo(item, index)">
                <div class="listTitle-L">
                  <el-icon>
                    <Film />
                  </el-icon>
                  <div style="display: inline-block;padding-left: 4px;">{{ item.videoName }}</div>
                </div>
                <div class="listTitle-R">{{ item.createDate }}</div>
              </div>
            </div> -->
            <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @open="handleOpen"
              @close="handleClose">
              <el-sub-menu :index="item.id + ''" v-for="(item, index) in videoList" :key="index">
                <template #title>
                  <span>{{ item.subjectName }}</span>
                </template>
                <el-menu-item v-for="(ite, ind) in item.videos" :key="ind" :index="item.id + '-' + ite.id"
                  @click="chooseVideo(ite, item, index, ind)">
                  <div class="videoTitleItem">
                    <div>{{ ite.videoName }}</div>
                    <div>{{ ite.state }}</div>
                  </div>
                </el-menu-item>

              </el-sub-menu>
            </el-menu>
          </div>
          <!-- <div class="videoListPage">
            <el-button type="primary" :disabled="loadAllFlag" :loading="loadFlag" @click="loadMore">{{ loadText
            }}</el-button>
          </div> -->
        </div>
        <div class="video-text" v-if="equipment == 'PC'">
          <div class="videoTextB">{{ videoIntroForm.videoName }}</div>
          <div class="videoTextB" style="text-align: right;color: #8a8a8a;padding-top: 20px;"
            v-if="videoIntroForm.createDate">上架时间：{{ videoIntroForm.createDate.split(" ")[0] }}</div>
          <div class="videoTextT">{{ videoIntroForm.videoIntro }}</div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogLoginFormVisible" title="" :width="dialogWidth">
      <h2 style="padding: 0 0 20px 0;">用户登录</h2>
      <div class="orgCode">
        <el-input type="text" size="large" placeholder="请输入手机号" v-model="loginForm.mobile" />
      </div>
      <div class="code" style="padding-bottom: 10px;">
        <el-input type="text" size="large" placeholder="请输入验证码" v-model="loginForm.code" maxlength="6">
          <template #append>
            <el-button class="codes" :disabled="codeDisabled" @click="getCodes">{{
              codeName
            }}</el-button>
          </template>
        </el-input>

      </div>
      <el-button class="login-btn" @click="loginData">登 录</el-button>
      <div class="loginFooter">
        <el-checkbox v-model="agreeChecked" label="我已阅读并同意" size="large" /><a
          href="https://rongxinchain.com/gch-tiaojie-video-_userprotocol.html">《用户协议》</a>和<a
          href="https://rongxinchain.com/gch-tiaojie-video-_privacypolicy.html">《隐私协议》</a>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  Film
} from '@element-plus/icons-vue'
import { getCode, mediatorTrainSubjectList, studyMemberLogin, getVideoUrlsByVideoId, getVideoPlayInfo, saveVideoPlayInfo, getCurrentMemberStudyInfo } from "@/api/index";
import Player, { Events } from 'xgplayer'
import 'xgplayer/dist/index.min.css'
import { ref, unref, onMounted, watch, onBeforeUnmount, nextTick } from "vue";
import { ArrowDown } from '@element-plus/icons-vue'
import { ElMessage } from "element-plus";
const agreeChecked = ref(false)
const handleOpen = (key, keyPath) => {
  console.log(key, keyPath)
}
const handleClose = (key, keyPath) => {
  console.log(key, keyPath)
}

const dialogLoginFormVisible = ref(false)
const loginForm = ref({
  mobile: "",
  code: ""
})
const codeName = ref("获取验证码")
const codeDisabled = ref(false)
const countdown = ref()
const getCodes = async () => {
  if (loginForm.value.mobile == "") {
    ElMessage({
      message: "请输入手机号",
      type: "warning",
    });
    return;
  }
  const result = await getCode({ mobile: loginForm.value.mobile });
  // console.log("result", result);
  if (result.code == 0) {
    codeDisabled.value = true;
    // 60秒禁止发送
    countdown.value = 60;
    const timer = setInterval(() => {
      // console.log("计时器");
      countdown.value--;
      if (countdown.value <= 0) {
        clearInterval(timer);
        codeName.value = "重新发送";
        codeDisabled.value = false;
      } else {
        codeName.value = `${countdown.value}秒`;
        codeDisabled.value = true;
      }
    }, 1000);
  } else {
    ElMessage({
      message: result.msg,
      type: "warning",
    });
  }
}
const loginData = async () => {
  if (agreeChecked.value == false) {
    ElMessage({
      message: "请先同意用户协议和隐私政策",
      type: "warning",
    });
    return;
  }
  if (loginForm.value.mobile == "" || loginForm.value.mobile == null) {
    ElMessage({
      message: "请输入手机号",
      type: "warning",
    });
    return;
  }
  if (loginForm.value.mobile == "" || loginForm.value.code == null) {
    ElMessage({
      message: "请先获取验证码",
      type: "warning",
    });
    return;
  }
  const res = await studyMemberLogin(loginForm.value)
  console.log(res, "studyMemberLogin");
  if (res.code == 0) {
    ElMessage({
      title: "成功",
      message: "登录成功",
      type: "success",
    });
    loginText.value = "退出登录"
    window.localStorage.setItem("token", res.data);
    await getList()
    await getVideoUrl()
    await getTimeStart()
    await intiPlayer()
    dialogLoginFormVisible.value = false
  } else {
    ElMessage({
      message: res.msg,
      type: "warning",
    });
  }

}
var defaultVideo = require("@/assets/back.mp4")
// const videoUrl = ref("//sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-720p.mp4")
const videoUrl = ref(defaultVideo)
const imgUrl = ref("")
const playerRef = ref()
const videoEl = ref()
const videoWidth = ref()
const videoHeight = ref()
const startTime = ref(null)//设置起播时间
const currentTime = ref(0)
const intiPlayer = async () => {
  if (!unref(videoEl)) return
  playerRef.value = new Player({
    autoplay: false,
    // url: defaultVideo, //视频源
    url: videoUrl.value, //视频源
    poster: imgUrl.value, //封面图
    startTime: startTime.value,//起播时间
    el: unref(videoEl), //容器
    width: videoWidth.value,
    height: videoHeight.value,
    miniprogress: true,//底部迷你进度条
    progress: {
      closeMoveSeek: true, // 禁用拖动进度条 
      isCloseClickSeek: true, // 禁用点击进度条跳转 
    },
    mobile: {
      gestureX: false, // 禁用移动端横向滑动调整进度 
    },
  })
  playerRef.value.on(Events.USER_ACTION, async (data) => {
    // data结构如下
    // if(data.from==true){
    //   setTimeout(() => {
    //     playerRef.value.pause()
    //   }, 1);
    // }
    /**
     * data = {
     *   action: String,        // 用户行为
     *   pluginName: String,    // 从哪个插件触发
     *   props: [{              // 发生变化的属性列表
     *     props: String,       // 发生变化的属性
     *     from: any,           // 变化前的值
     *     to: any              // 变化后的值
     *   }],
     *   event: Event,          // 事件
     *   currentTime: Number,   // 当前播放时间
     *   duration: Number,      // 当前播放器时长
     *   ended:  Boolean,        // 是否播放结束
     *   paused:  Boolean,       // 是否暂停
     * }
     */
  })
  playerRef.value.on(Events.PLAY, async (data) => {
    // console.log(data.from, playerRef.value, "data")
    var token = window.localStorage.getItem("token");
    if (token == null || token == "") {
      playerRef.value.pause()
      dialogLoginFormVisibleOpen()
    } else {
      timerFunction()
    }
  })
  playerRef.value.on(Events.PAUSE, async (data) => {
    timerEnd()
  })

  playerRef.value.on(Events.TIME_UPDATE, () => {

    // 获取用户播放进度
    // if (playerRef.value.currentTime > currentTime) {
    currentTime.value = playerRef.value.currentTime
    // }
    if (videoList.value[currentSubjectIndex.value].videos[currentVideoIndex.value].state == "待开始") {
      videoList.value[currentSubjectIndex.value].videos[currentVideoIndex.value].state = "学习中"
    }
  })
  playerRef.value.on(Events.ENDED, async (data) => {
    console.log(data, "结束")
  })

}
const dialogLoginFormVisibleOpen = () => {
  dialogLoginFormVisible.value = true
  loginForm.value = {
    mobile: "",
    code: ""
  }
}
onMounted(() => {
  intiPlayer()
  getList()
  getWindowResize()
  window.addEventListener('resize', getWindowResize)
})

onBeforeUnmount(() => {
  unref(playerRef)?.destroy()
})
const pageForm = ref({
  current: 1,
  size: 10
})
const total = ref(0)
const videoList = ref([])
const teacherInfo = ref({

})
const currentVideoTotalTime = ref()
var teacherHeadUrl = require("@/assets/user.png")
const getList = async () => {
  loadText.value = "加载中"
  loadFlag.value = true
  const res = await mediatorTrainSubjectList()
  // console.log(res, "mediatorTrainSubjectList")
  // total.value = res.data.total
  videoList.value = res.data
  activeIndex.value = videoList.value[0].id + '-' + videoList.value[0].videos[0].id

  imgUrl.value = videoList.value[0].videos[0].videoCoverUrl
  videoIntroForm.value = videoList.value[0].videos[0]
  videoId.value = videoList.value[0].videos[0].id
  teacherInfo.value = videoList.value[0].videos[0].teacherInfo
  loadText.value = "加载更多"
  loadFlag.value = false
  loadAllFlag.value = false
  if (total.value == videoList.value.length) {
    loadText.value = "已加载全部"
    loadAllFlag.value = true
  }
  var token = window.localStorage.getItem("token");
  if (token == null || token == "") {
  } else {
    const list = await getCurrentMemberStudyInfo()
    // console.log(list.data,videoList.value,"getCurrentMemberStudyInfo")

    videoList.value.forEach(async (item, index) => {
      // console.log(item,index)
      if (item.videos.length > 0) {
        item.videos.forEach(async (videoItem, videoIndex) => {
          await getVideoState(videoItem.id, index, videoIndex, list.data)
        })
      }
      // 
    })
    currentVideoTotalTime.value = videoList.value[0].videos[0].totalTime
    currentFinishFlag.value = videoList.value[0].videos[0].finishFlag
    // return
    await getVideoUrl()
    await getTimeStart()
    // console.log(videoList.value, "videoList.value")
  }

  unref(playerRef)?.destroy()
  intiPlayer()
}
//加载更多
const loadFlag = ref(false)
const loadAllFlag = ref(false)
const loadText = ref("加载更多")
const loadMore = () => {
  pageForm.value.current = pageForm.value.current + 1
  getList()
}
//选择视频
const activeIndex = ref("1-1")
// const videoIndex = ref(0)
const videoIntroForm = ref("")
const videoId = ref("")
const currentSubjectIndex = ref(0)
const currentVideoIndex = ref(0)
const currentFinishFlag = ref()

const chooseVideo = async (video, subjectDesc, subjectIndex, videoIndex) => {
  console.log(subjectIndex, videoIndex, "subjectIndex, videoIndex")
  currentSubjectIndex.value = subjectIndex
  currentVideoIndex.value = videoIndex
  timerEnd()
  activeIndex.value = subjectDesc.id + '-' + video.id
  console.log(video, subjectDesc, "activeIndex.value")
  // videoIndex.value = index
  imgUrl.value = video.videoCoverUrl
  videoIntroForm.value = video
  videoId.value = video.id
  currentVideoTotalTime.value = video.totalTime
  currentFinishFlag.value = video.finishFlag
  teacherInfo.value = video.teacherInfo
  var token = window.localStorage.getItem("token");
  if (token == null || token == "") {
  } else {
    await getVideoUrl()
    await getTimeStart()
  }

  unref(playerRef)?.destroy()
  intiPlayer()
  // console.log(video.videoCoverUrl, index)

}
// 屏幕宽度
const windowWidth = ref(0)
// 屏幕高度
const windowHeight = ref(0)
const equipment = ref("PC")
const dialogWidth = ref()
// 获取屏幕尺寸
const getWindowResize = function () {
  windowWidth.value = window.innerWidth
  windowHeight.value = window.innerHeight
  if (windowWidth.value < 650) {
    videoWidth.value = "100%"
    equipment.value = "phone"
    dialogWidth.value = windowWidth.value - 20
    videoHeight.value = "400px"
  } else {
    videoWidth.value = "100%"
    equipment.value = "PC"
    dialogWidth.value = 500
    videoHeight.value = "500px"
  }
}
const skipGuanWang = (url) => {
  window.location.href = url
}
const timer = ref()
const timerFunction = () => {
  timer.value = setInterval(() => {
    // console.log(currentSubjectIndex.value,currentVideoIndex.value,videoList.value[currentSubjectIndex.value].videos[currentVideoIndex.value],"currentTime")
    // console.log(currentTime.value, currentVideoTotalTime.value, currentFinishFlag.value, "currentTime.value >= currentVideoTotalTime.value")
    if (currentFinishFlag.value !== 1) {
      if (currentTime.value > 0 && currentTime.value < currentVideoTotalTime.value) {
        videoList.value[currentSubjectIndex.value].videos[currentVideoIndex.value].state = "学习中"
      } else if (currentTime.value >= currentVideoTotalTime.value) {
        videoList.value[currentSubjectIndex.value].videos[currentVideoIndex.value].state = "已完成"
      }
    }

    const res = saveVideoPlayInfo({
      recordInfo: currentTime.value,
      videoId: videoId.value,
    })
  }, 5000);
}
const timerEnd = () => {
  // console.log("切换")
  clearInterval(timer.value);
  timer.value = ""
}
const getVideoUrl = async () => {
  await getVideoUrlsByVideoId({ videoId: videoId.value }).then((res) => {
    console.log(res)
    videoUrl.value = res.data.videoUrl
  })
}
const getTimeStart = async () => {

  const res = await getVideoPlayInfo({ videoId: videoId.value })
  console.log(res, "getVideoPlayInfo")
  if (res.data !== "" || res.data !== null) {
    startTime.value = res.data.recordInfo
  }

  // videoUrl.value = ress.data.videoUrl
}
const getVideoState = async (videoId, subjectIndex, videoIndex, list) => {
  // console.log(videoId,subjectIndex,videoIndex,list,"getVideoState")
  list.forEach(item => {
    if (item.videoId == videoId) {
      // console.log(item.recordInfoTime,item.totalTime,item.recordInfoTime*1<item.totalTime*1,"item.recordInfoTime>=item.totalTime")
      videoList.value[subjectIndex].videos[videoIndex].recordInfoTime = item.recordInfoTime * 1
      videoList.value[subjectIndex].videos[videoIndex].totalTime = item.totalTime * 1
      videoList.value[subjectIndex].videos[videoIndex].finishFlag = item.finishFlag
      if (item.finishFlag == 1) {
        videoList.value[subjectIndex].videos[videoIndex].state = "已完成"
      } else if (item.recordInfoTime * 1 == 0) {
        videoList.value[subjectIndex].videos[videoIndex].state = "待开始"
      } else if (item.recordInfoTime * 1 < item.totalTime * 1) {
        videoList.value[subjectIndex].videos[videoIndex].state = "学习中"
      } else if (item.recordInfoTime * 1 >= item.totalTime * 1) {
        videoList.value[subjectIndex].videos[videoIndex].state = "已完成"
      }
    }
  })
}
// CDB66D71008F834F13D2747B25E3457F1872D0527F9D72FBE50E96EFE
const quit = () => {
  if (loginText.value == "退出登录") {
    // loginText.value = "请登录"
    // unref(playerRef)?.destroy()
    // videoUrl.value = require("@/assets/back.mp4")
    // intiPlayer()
    // timerEnd()
    window.localStorage.clear()
    ElMessage({
      title: "成功",
      message: "退出成功",
      type: "success",
    });
    location.reload();
  } else {
    dialogLoginFormVisibleOpen()
  }

}
const loginText = ref("请登录")
var token = window.localStorage.getItem("token");
if (token == null || token == "") {
  loginText.value = "请登录"
} else {
  loginText.value = "退出登录"
}

</script>
<style scoped>
.header {
  box-sizing: border-box;
  width: 100%;
  height: 70px;
  border-bottom: 1px solid #68696e;
  padding: 0 100px;
  display: flex;
  justify-content: space-between;
}

.header-left img {
  max-width: 430px;
}

.header-right {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  width: 250px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
}

.video {
  padding: 10px 100px;
}

.videoPlay {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.videoPlay-v {
  width: 60%;
}

.videoEl {
  width: 100%;
  box-sizing: border-box;
  height: 500px;
}

.video-text {
  box-sizing: border-box;
  width: 38%;
  padding: 10px 20px;
  background-color: #fff;
  text-align: left;
  margin-top: 20px;
}

.videoTextB {
  line-height: 40px;
}

.video-text :nth-child(1) {
  font-weight: bold;
  font-size: 18px;
}

.video-text :nth-child(2) {
  font-size: 14px;
}

.videoTextT {
  /* text-indent: 2em; */
  padding-top: 10px;
}

.myvideo {
  max-height: 600px;
}

.videoPlay video {
  width: 100%;
}

.videoBody {
  display: flex;
  justify-content: space-between;
}

.videoList {
  margin-top: 20px;
  padding-top: 10px;
  width: 60%;
  background-color: #fff;
}

.videoTitleList {
  width: calc(100% - 40px);
  padding: 10px 20px;
  line-height: 28px;
}

.videoTitleItem {
  display: flex;
  justify-content: space-between;
}

.listTitle {
  cursor: pointer;
  /* border: 1px solid #cb2a2a;
  background-color: #fef0f0; */
  text-align: left;
  padding: 4px 6px;
  border-radius: 4px;
  font-weight: 700;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

.listTitle-R {
  color: #999999;
  font-size: 12px;
  font-weight: 400;
}

.on {
  color: #cb2a2a;
  background-color: #f0f3f5;
}

.videoListPage {
  display: flex;
  justify-content: center;
  padding: 10px;
}

.videoListPage button {
  width: 50%;
  line-height: 40px;
  height: 40px;
  font-size: 18px;
}

.tutorInfo {
  width: 38%;
  box-sizing: border-box;
  background-color: #fff;
  padding: 20px;
}

.tutorTop {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  height: 80px;
}

.tutorTopImg {
  width: 80px;
  border-radius: 50%;
  overflow: hidden;
}

.tutorTopImg img {
  width: 80px;
  height: 80px;
}

.tutorTopText {
  padding-left: 30px;
  line-height: 100px;
}

.tutorText {
  text-align: left;
  text-indent: 2rem;
  padding-top: 10px;
}

:deep(.el-dropdown) {
  font-size: 16px;
  font-weight: 400;
}

.orgCode,
.code {
  display: flex;
  justify-content: space-between;
  /* padding-bottom: 16px; */
}

.orgCode {
  padding-bottom: 16px;
}

.orgCode .el-input__inner {
  width: 100%;
  margin-bottom: 20px;
}

.code .el-input__inner {
  width: 50%;
}

.code .codes {
  /* float: right; */
  /* width: 40%; */
  height: 40px;
  text-align: center;
  color: red;
}

.code .codes:hover {
  color: red;
}

.login-btn {
  margin: 0 auto;
  line-height: 50px;
  height: 50px;
  width: 100%;
  background-color: #cf3232;
  color: #fff;
  margin-top: 20px;
  font-size: 18px;
  border-radius: 6px;
}

.login-btn:hover {
  background-color: #cf3232;
  color: #fff;
}

.loginFooter {
  font-size: 14px;
  color: #999;
  text-align: left;
  padding: 15px 0;
}

.loginFooter a {
  color: #cf3232;

}

:deep(.el-checkbox__input) {
  padding-top: 6px;
}

:deep(.el-checkbox.el-checkbox--large .el-checkbox__label) {
  padding-top: 8px;
}

:deep(.el-overlay) {
  background-color: rgba(0, 0, 0, 0.85);
}

:deep(.el-dialog) {
  border-radius: 20px;
  padding: 0 40px 10px 40px;
}

:deep(.el-input__wrapper) {
  border-radius: 6px;
}

:deep(.el-input__inner) {
  height: 50px;
  line-height: 50px;
}

/* 播放按钮 */
/* video::-webkit-media-controls-play-button {
  display: none;
} */
.el-tooltip__trigger:first-child:focus-visible {
  outline: unset;
}

/* 隐藏倍速播放 */
:deep(.xgplayer .xg-options-icon.show) {
  display: none;
}

:deep(.el-menu) {
  border-right: 0px solid transparent;
}

:deep(.el-sub-menu__title) {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.el-sub-menu__title span) {
  text-align: left;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.el-sub-menu__title:hover) {
  background-color: #fef0f0;
}

:deep(.el-sub-menu .el-menu-item) {
  text-align: left;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.el-menu-item.is-active) {
  color: #cf3232;
  font-weight: bold;

}

:deep(.el-menu-item:hover) {
  background-color: #fef0f0;
}

@media (max-width: 650px) {
  .header {
    padding: 0 10px;
  }

  .header-left img {
    height: 70px;
  }

  .video {
    padding: 10px 0;
  }

  .videoPlay {
    flex-wrap: wrap;
  }

  .videoPlay-v {
    width: 100%;
  }

  .myvideo {
    max-height: 400px;
  }

  .video-text {
    width: 100%;
    padding: 10px 20px 20px 10px;
    text-align: left;
    margin-top: 10px;
  }

  .videoBody {
    flex-wrap: wrap;
  }

  .videoList {
    width: 100%;
  }

  .listTitle-R {
    display: none;
  }

  .videoListPage button {
    width: 100%;
  }

  .tutorInfo {
    width: 100%;
    margin-top: 10px;
  }

  :deep(.el-dialog) {
    padding: 10px;
  }
}
</style>
